import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import api from "@/lib/api";

const LABEL = { ok: "OK", unknown_key: "nieznany klucz", invalid_signature: "podrobiony podpis", build_mismatch: "obca paczka", revoked: "odwołana",
  expired: "wygasła", hw_mismatch: "inny sprzęt", multi_hw: "kopia (wiele HWID)", multi_domain: "wiele domen", revoked_contact: "odwołana się melduje" };

function Fit({ items }) {
  const map = useMap();
  useEffect(() => {
    if (!items.length) return;
    if (items.length === 1) map.setView([items[0].lat, items[0].lng], 6);
    else map.fitBounds(items.map((i) => [i.lat, i.lng]), { padding: [30, 30], maxZoom: 8 });
  }, [items, map]);
  return null;
}

export function InstallMap({ reloadKey }) {
  const [d, setD] = useState({ items: [], unlocated: 0 });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get("/license/installations/map").then((r) => setD(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [reloadKey]);
  const bad = d.items.filter((i) => i.suspicious).length;
  return (
    <div className="mb-3" data-testid="licmon-map">
      <div className="flex flex-wrap gap-3 text-[11px] mb-1 text-slate-400">
        <span>Mapa instalacji (lokalizacja przybliżona po IP)</span>
        <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-emerald-500" />OK: {d.items.length - bad}</span>
        <span className="flex items-center gap-1" data-testid="licmon-map-suspicious"><span className="w-2.5 h-2.5 rounded-full bg-red-500" />podejrzane: {bad}</span>
        {d.unlocated > 0 && <span data-testid="licmon-map-unlocated">bez lokalizacji: {d.unlocated}</span>}
        {loading && <span>ładowanie…</span>}
      </div>
      <div className="h-72 rounded border border-slate-700 overflow-hidden relative z-0 isolate">
        <MapContainer center={[52, 19]} zoom={5} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
          <Fit items={d.items} />
          {[...d.items].sort((a, b) => a.suspicious - b.suspicious).map((i) => (
            <CircleMarker key={i.id} center={[i.lat, i.lng]} radius={i.suspicious ? 9 : 7}
              pathOptions={{ color: i.suspicious ? "#ef4444" : "#10b981", fillColor: i.suspicious ? "#ef4444" : "#10b981", fillOpacity: 0.75, weight: 2 }}>
              <Popup>
                <div className="text-xs" data-testid={`licmon-map-pop-${i.id}`}>
                  <b>{i.company || "— nieznany klucz —"}</b><br />{i.domain || i.ip} · {[i.city, i.country].filter(Boolean).join(", ")}<br />
                  Wersja: {i.version || "—"} · ostatni kontakt: {(i.last_seen || "").slice(0, 16).replace("T", " ")}<br />
                  Status: {LABEL[i.status] || i.status}{i.dead ? " · nie odzywa się" : ""}{i.revoked ? " · odwołana" : ""}
                  {i.flags.filter((f) => f !== i.status).map((f) => ` · ${LABEL[f] || f}`)}
                </div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
